/**
 * Position entity constants
 */

export const MAX_POSITION_LENGTH = 255;
